<ion-content class="ion-padding">
  <div [formGroup]="myForm">
    <ion-item>
      <ion-label position="stacked">Nombre del hidrante</ion-label>
      <ion-input
        formControlName="name"
        placeholder="Nombre del hidrante"></ion-input>
    </ion-item>
  </div>
</ion-content>
